import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LayersIcon from "@mui/icons-material/Layers";
import { Button, ButtonGroup, Link, Popover } from "@mui/material";
import { productCodeToExplorerLayerIdMappings } from "pages/geoscape-data/constants";
import { useState } from "react";
import { useHistory } from "react-router";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";
import { viewDatasetInExplorer } from "../catalogue-page";

// Reverse mapping for NATIONAL X back to backend keys
const REVERSE_PRODUCT_MAPPING: Record<string, string> = {
  "NATIONAL PLANNING": "GEOSCAPE PLANNING",
  "NATIONAL PLANNING INSIGHTS": "GEOSCAPE PLANNING INSIGHTS",
  "NATIONAL BUILDINGS": "GEOSCAPE BUILDINGS",
  "NATIONAL CADASTRE": "GEOSCAPE CADASTRE",
  "NATIONAL PROPERTY": "GEOSCAPE PROPERTY",
  "NATIONAL TREES": "GEOSCAPE TREES",
  "NATIONAL ROADS": "GEOSCAPE ROADS",
  "NATIONAL AIRPORTS": "GEOSCAPE AIRPORTS",
  "NATIONAL RAIL": "GEOSCAPE RAIL",
  "NATIONAL LOCALITIES": "GEOSCAPE LOCALITIES",
  "NATIONAL LOCAL GOVERNMENT AREAS": "GEOSCAPE LOCAL GOVERNMENT AREAS",
  "NATIONAL WARDS": "GEOSCAPE WARDS",
  "NATIONAL SOLAR": "GEOSCAPE SOLAR",
  "NATIONAL SURFACE COVER": "GEOSCAPE SURFACE COVER",
  "NATIONAL GREENSPACE": "GEOSCAPE GREENSPACE",
  "NATIONAL HYDROLOGY": "GEOSCAPE HYDROLOGY",
  "NATIONAL ELECTORAL BOUNDARIES": "ELECTORAL BOUNDARIES",
  "NATIONAL POSTCODE BOUNDARIES": "POSTCODE BOUNDARIES",
};

const CustomButtonGroup = ({ licenced, displayProduct }: any) => {
  const { showNewMessage } = useIntercom();
  const history = useHistory();

  // Reverse map NATIONAL X back to backend key for internal lookups
  const backendProductName = REVERSE_PRODUCT_MAPPING[displayProduct] || displayProduct;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
        color="primary"
      >
        {licenced && (
          <Button
            LinkComponent={Link}
            href={`${Routes.dataDownload}?product=${displayProduct}&licenced=${licenced}`}
            startIcon={<DownloadIcon />}
          >
            Download
          </Button>
        )}
        {!licenced && (
          <Button
            onClick={() => {
              showNewMessage(
                `I’d like to talk to someone about "${displayProduct}"`
              );
            }}
            startIcon={<EmailIcon />}
          >
            Contact
          </Button>
        )}
        <Button
          color="primary"
          disabled={true}
          startIcon={<DownloadIcon />}
          onClick={() => {}}
        >
          Sample
        </Button>
        <Button
          color="primary"
          startIcon={<KeyboardArrowDownIcon />}
          onClick={handleClick}
        >
          More
        </Button>
      </ButtonGroup>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <ButtonGroup orientation="vertical" variant="contained">
          <Button
            key="create-key"
            color="primary"
            disabled
            startIcon={<AddIcon />}
          >
            Create Key
          </Button>
          <Button
            key="create-key"
            color="primary"
            disabled={!productCodeToExplorerLayerIdMappings.get(backendProductName)}
            onClick={() => viewDatasetInExplorer(displayProduct, history)}
            startIcon={<LayersIcon />}
          >
            Map
          </Button>
        </ButtonGroup>
      </Popover>
    </div>
  );
};

export default CustomButtonGroup;
